import * as React from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlusCircle,
    faFileExcel,
    faList,
} from "@fortawesome/free-solid-svg-icons";
import { MenuRender } from "../../../../Shared/GridComponents/CommonComponents";
import { GridDetailRow } from "@progress/kendo-react-grid";
import { currencyFormatter } from "../../../../../HelperMethods";

export const downloadTemplate = (data?) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => data()}>
            <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Download Rate Card{" "}
        </div>
    );
};

export const contentAddRender = (uploadControl) => {

    return (<div>
        <div className="pb-1 pt-1 w-100  myorderGlobalicons" onClick={() => { uploadControl.click() }}>
            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"} />
            Import Rate Card
        </div>
    </div>
    );
};

export const CustomMenu = (excelData, select, templateData?, uploadControl?) => {
    return (
        <>
            <input
                type="file"
                multiple
                accept="application/xls,application/xlsx, .xlsx, .xls"
                ref={(ref) => uploadControl = ref}
                style={{ display: 'none' }}
                onChange={(e) => select(e)}
            />
            <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
                <MenuItem render={MenuRender}>
                    <MenuItem render={() => downloadTemplate(templateData)} />
                    <MenuItem render={() => contentAddRender(uploadControl)} key={"addBtn"} />
                </MenuItem>
            </Menu>
        </>
    );
};

export function DefaultActions(props) {
    const { dataItem } = props;
    var defaultActions = [];
    return defaultActions;
}

export class DetailColumnCell extends React.Component<{ dataItem: any; expandChange: any }> {
    render() {
        let dataItem = this.props.dataItem;
        return (
            <td contextMenu="View More" style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                    icon={faList}
                    style={{ marginLeft: "0px!important", marginTop: "0", fontSize: "16px" }}
                    className={"active-icon-blue left-margin cursorPointer"}
                    onClick={() => this.props.expandChange(dataItem)}
                />
            </td>
        );
    }
}

export class ViewMoreComponent extends GridDetailRow {
    render() {
        const dataItem = this.props.dataItem;
        return <DialogBox {...dataItem} />;
    }
}

export const DialogBox = (props) => {
    return (
        <div className="row">
            <div className="col-12 col-lg-11 text-dark">
                <div className="row ml-0 mr-0 mt-1">
                    <div className="col-12 pl-0 text-right">
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>% Suppress :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {props.suppressPer}</label>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Suppress Amount :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {currencyFormatter(props.suppressionRate)}</label>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Target Rate :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {props.targetRate != null ? currencyFormatter(props.targetRate) : currencyFormatter(props.maxBillRate)}</label>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Max. Holiday Bill Rate :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {currencyFormatter(props.maxHolidayBillRate)}</label>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Tags :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {props.tags || "-"}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};